import {useEffect, useState} from "react";

export default function PartnerForm({
  initial = null,
  onSubmit,
  loading,
  onCancel,
}) {
  const [partnerName, setPartnerName] = useState("");
  const [partnerLocation, setPartnerLocation] = useState("");
  const [targetTrainees, setTargetTrainees] = useState("");

  useEffect(() => {
    if (initial) {
      setPartnerName(initial.partnerName || "");
      setPartnerLocation(initial.partnerLocation || "");
      setTargetTrainees(
        typeof initial.targetTrainees === "number"
          ? String(initial.targetTrainees)
          : ""
      );
    }
  }, [initial]);

  return (
    <form
      className="space-y-4"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({
          partnerName,
          partnerLocation,
          targetTrainees: targetTrainees === "" ? null : Number(targetTrainees),
        });
      }}
    >
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Partner Name
        </label>
        <input
          value={partnerName}
          onChange={(e) => setPartnerName(e.target.value)}
          required
          className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Partner Location
        </label>
        <input
          value={partnerLocation}
          onChange={(e) => setPartnerLocation(e.target.value)}
          required
          className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Target Trainees (optional)
        </label>
        <input
          type="number"
          min={0}
          value={targetTrainees}
          onChange={(e) => setTargetTrainees(e.target.value)}
          className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., 120"
        />
      </div>

      <div className="flex items-center gap-2">
        <button
          type="submit"
          disabled={loading}
          className="rounded-md bg-myblue px-4 py-2 text-white disabled:opacity-50"
        >
          {initial ? "Update Partner" : "Create Partner"}
        </button>
        {onCancel ? (
          <button
            type="button"
            onClick={onCancel}
            className="rounded-md border px-4 py-2"
          >
            Cancel
          </button>
        ) : null}
      </div>
    </form>
  );
}
